export const debug = {
  information: 'Debug information',
  parameters: 'Parameters',
  errorCode: 'Error code',
  details: 'Details',
  noDetails: 'No details',
  error: 'Error',
  showInfo: 'Show debug information',
  hideInfo: 'Hide debug information'
}
